import {  GET_ACCOUNT_INFO_DETAIL_START,
         GET_ACCOUNT_INFO_DETAIL_ERROR,
        GET_ACCOUNT_INFO_DETAIL_SUCCESS,
        GET_CONTACT_HISTORY_DETAIL_SUCCESS,
        GET_CONTACT_HISTORY_DETAIL_ERROR,
        GET_CONTACT_HISTORY_DETAIL_START
} from 'Constant'
  
const initialState = {
    loading: false,
    data: [],
    constactHistoryDetail:[]
   
};
  
export default function AccountInfoReducer(
    state = { ...initialState },
    action
) {
    switch (action.type) {
      case GET_ACCOUNT_INFO_DETAIL_START:
        return {
          ...state,
          loading: true,
        };
      case GET_ACCOUNT_INFO_DETAIL_SUCCESS:
        return {
          ...state,
          data: action.payload,
          loading: false,
        };
      case GET_ACCOUNT_INFO_DETAIL_ERROR:
        return {
          ...state,
          loading: false,
          message: action.error.message,
        };
        case GET_CONTACT_HISTORY_DETAIL_START:
          return {
            ...state,
            loading: true,
          };
        case GET_CONTACT_HISTORY_DETAIL_SUCCESS:
          return {
            ...state,
            constactHistoryDetail: action.payload,
            loading: false,
          };
        case GET_CONTACT_HISTORY_DETAIL_ERROR:
          return {
            ...state,
            loading: false,
            message: action.error.message,
          };
    
      default:
        return state;
    }
}
  